import { wholeMoneyFormatter } from "helpers/formatCurrency";
import { fetch as router } from "helpers/router";
import request from "utils/request";
import retrieveShareReferral from "utils/ShareReferral";

export const stripShareSuffix = () => {
  if (!/\/share\/?$/.test(window.location.pathname)) {
    return;
  }
  const basePath = window.location.pathname.replace(/\/share\/?$/, "");
  const { search, hash } = window.location;
  window.history.replaceState(null, "", (basePath || "/") + search + hash);
};

export const buildShareUrl = (baseUrl) => {
  const { pds } = retrieveShareReferral();
  if (!pds) {
    return baseUrl;
  }
  const url = new URL(baseUrl);
  url.searchParams.set("pds", pds);
  return url.toString();
};

export const fetchSupporters = async (type, campaignId, fundraiserId, offset, limit) => {
  let supporters;

  const url = type === "campaign"
    ? `${router("api.v2.campaigns.supporters.index", { campaign: campaignId })}?limit=${limit}&offset=${offset}`
    : `${router("api.v2.fundraisers.supporters.index", { fundraiser: fundraiserId })}?limit=${limit}&offset=${offset}`;

  await fetch(request(url))
    .then((res) => {
      supporters = res.json();
    })
    .catch(() => {
      console.error("Unable to get supporters");
    });

  return supporters;
};

export const getEntity = (type, campaign, fundraiser) => {
  if (type === "campaign") {
    if (!campaign) {
      return {};
    }
    return {
      raised: wholeMoneyFormatter(campaign.collected.amount),
      target: wholeMoneyFormatter(campaign.target.amount),
      collectedTargetHidden: campaign.collectedTargetHidden,
      collectedTargetProgressPercentHidden: campaign.collectedTargetProgressPercentHidden,
      collectedTargetProgressPercent: campaign.collectedTargetProgressPercent,
      video: campaign?.video[0]?.publicUrl,
      title: campaign.title,
      content: campaign.content,
      ownerName: campaign.ownerName,
    };
  }
  if (type === "fundraiser") {
    if (!fundraiser) {
      return {};
    }

    const raised = wholeMoneyFormatter(fundraiser.collected.amount);
    const target = wholeMoneyFormatter(fundraiser.target.amount);
    return {
      raised,
      target,
      collectedTargetHidden: false,
      collectedTargetProgressPercentHidden: false,
      collectedTargetProgressPercent: (raised / target) * 100,
      video: fundraiser.video[0]?.publicUrl,
      title: fundraiser.fundraiserName,
      content: fundraiser.content,
      ownerName: fundraiser.fundraiserName,
      teamName: fundraiser.team?.title,
      teamSlug: fundraiser.team?.slug,
    };
  }
};

const fetchShares = async (campaign) => {
  const url = router("api.v2.campaigns.statistics.share", { campaign });

  return fetch(request(url))
    .then((response) => {
      if (!response.status === 200) {
        throw new Error(response.status);
      }
      return response;
    })
    .then((response) => response.json());
};

export default fetchShares;
